import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  paper: {
    marginTop: 100,
    paddingTop: 40,
    paddingBottom: 15,
    paddingLeft: 36,
    paddingRight: 36,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    margin: theme.spacing(1),
    height: 47,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  formControl: {
    margin: 0,
  },
  inputLabel: {
    marginTop: 20,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  link: {
    textTransform: 'uppercase',
  },
  version: {
    marginTop: 25,
    marginRight: -20,
  },
}));
